<template>
  <div class="card">
    <p class="title">您正在咨询订单：</p>
    <div class="line"></div>
    <p class="sub-title">{{ info.productName }}</p>
    <p class="text">实付款：{{ info.actualAmount }}</p>
    <p class="text">交易时间：{{ info.paymentTime }}</p>
    <p class="text">订单编号：{{ info.orderNo }}</p>
  </div>
</template>

<script>
import kylogger from "@ky/sdk/dist/log/kylogger";
export default {
  name: "OrderCard",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    kylogger.collect("SHOW", "VIP_ORDER_FEEDBACK", {});
    try {
      this.info = JSON.parse(this.data.content);
    } catch {}
  },
};
</script>

<style lang="less" scoped>
.card {
  width: 5.56rem;
  height: 3.12rem;
  margin-top: 0.32rem;
  color: rgba(255, 255, 255, 0.9);
  .line {
    width: 100%;
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 0.16rem auto;
  }
  .title {
    font-size: 0.28rem;
    line-height: 0.44rem;
    font-weight: 500;
  }
  .sub-title {
    font-size: 0.26rem;
    line-height: 0.44rem;
    margin-bottom: 0.02rem;
  }
  .text {
    font-weight: 400;
    font-size: 0.2rem;
    line-height: 0.42rem;
  }
}
</style>
